import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import Vue from 'vue';
import { extend } from 'vee-validate';
import { required, email, confirmed, max, min } from 'vee-validate/dist/rules';
import VueI18n from 'vue-i18n';
import de from '@/locales/de.json';
import en from '@/locales/en.json';
import es from '@/locales/es.json';
import fr from '@/locales/fr.json';
import it from '@/locales/it.json';
import nl from '@/locales/nl.json';
import pt from '@/locales/pt.json';
import { giftCardPriceValidator, discountInputValidator } from '~/helpers/validation-helper';
Vue.use(VueI18n);
export default (function (_ref) {
  var app = _ref.app,
    store = _ref.store;
  var currentApp = app;
  currentApp.i18n = new VueI18n({
    locale: store.state.i18n.currentLocale.language,
    fallbackLocale: 'fr',
    localeDir: 'locales',
    enableInSFC: true,
    messages: {
      fr: fr,
      en: en,
      de: de,
      es: es,
      it: it,
      nl: nl,
      pt: pt
    },
    silentTranslationWarn: process.env.NODE_ENV === 'production'
  });
  extend('required', _objectSpread(_objectSpread({}, required), {}, {
    message: currentApp.i18n.t('common.form.error.required')
  }));
  extend('giftCardPrice', _objectSpread(_objectSpread({}, giftCardPriceValidator), {}, {
    message: currentApp.i18n.t('gift-card.form.error.price')
  }));
  extend('discountInput', _objectSpread(_objectSpread({}, discountInputValidator), {}, {
    message: currentApp.i18n.t('gift-card.form.error.price')
  }));
  extend('email', _objectSpread(_objectSpread({}, email), {}, {
    message: currentApp.i18n.t('common.form.error.email')
  }));
  extend('confirmedEmail', _objectSpread(_objectSpread({}, confirmed), {}, {
    message: currentApp.i18n.t('common.form.error.confirmEmail')
  }));
  extend('max', _objectSpread(_objectSpread({}, max), {}, {
    message: function message(_, _ref2) {
      var length = _ref2.length;
      return currentApp.i18n.t('common.form.error.max', {
        length: length
      });
    }
  }));
  extend('min', _objectSpread(_objectSpread({}, min), {}, {
    message: function message(_, _ref3) {
      var length = _ref3.length;
      return currentApp.i18n.t('common.form.error.invalid', {
        length: length
      });
    }
  }));
});